/**
 * djb2 hash implementation: https://theartincode.stanis.me/008-djb2/
 *
 * @internal
 */
export const getHashCode = (value: any): number => {
    let strValue = value === undefined || value === null ? '' : value
    if (typeof value !== 'string') {
        try {
            strValue = JSON.stringify(value)
        } catch {
            strValue = ''
        }
    }

    let hash = 5381
    let view = Uint8Array.from(Array.from(strValue as string).map((l) => l.charCodeAt(0)))

    for (let num of view) {
        hash = ((hash << 5) + hash + num) & 0xffffffff
    }

    return hash
}

/**
 * Performs value comparison using getHashCode()
 *
 * @internal
 */
export const isEqual = (a: any, b: any): boolean => {
    return getHashCode(a) === getHashCode(b)
}
